import axios from 'axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function startHomeworkExport(homeworkTitle) {
    return {
        type: types.START_HOMEWORK_EXPORT,
        homeworkTitle
    };
}

export function stopHomeworkExport() {
    return {
        type: types.STOP_HOMEWORK_EXPORT
    };
}

export function resetFilesWord() {
    return {
        type: types.RESET_FILES_WORD
    };
}

export function changeRowNumber(homeworkTitle, rowNumber) {
    let filesName = [];
    for (let i = 1; i <= rowNumber; i++) {
        if (rowNumber === 1) {
            filesName.push({ homeworkTitle: homeworkTitle, homeworkFileDescription: '.docx' });
            filesName.push({ homeworkTitle: `Soluzioni - ${homeworkTitle}`, homeworkFileDescription: '.docx' });
        } else {
            filesName.push({ homeworkTitle: homeworkTitle, homeworkFileDescription: `_${i}.docx` });
            filesName.push({ homeworkTitle: `Soluzioni - ${homeworkTitle}`, homeworkFileDescription: `_${i}.docx` });
        }
    }
    return {
        type: types.CHANGE_ROW_NUMBER,
        rowNumber,
        filesName
    };
}

export function changeHighReadability() {
    return {
        type: types.HIGH_READABILITY_FLAG
    };
}

export function callT2P(t2pParam, homeworkId, exercises, taxonomy, homeworkType = 'teacher', originName, subjects) {
    const url = `${API_URL}/tutor2paper/`;
    return async dispatch => {
        dispatch({ type: types.CALL_T2P });
        try {
            const { data } = await axios.post(url, t2pParam);
            dispatch({
                type: types.CALL_T2P_SUCCESS,
                homeworkId,
                highReadability: t2pParam.isBES,
                rows: t2pParam.numberOfDocsToGenerate,
                audio: !!t2pParam.audio,
                homeworkType,
                exercises,
                taxonomy,
                originName,
                fileName: t2pParam.fileName,
                fileType: t2pParam.fileType,
                filesName: data.fileNameArray || [],
                subjects: subjects || []
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.CALL_T2P_FAILURE,
                error: e
            });
        }
    };
}

export function downloadWordFiles() {
    return {
        type: types.DOWNLOAD_FILES_WORD
    };
}

export function changeInputStyle() {
    return {
        type: types.CHANGE_INPUT_STYLE
    };
}

export function checkExistenceAndDownloadFile(fileUrl) {
    return async dispatch => {
        dispatch({ type: types.CHECK_FILE_EXISTENCE });
        try {
            const result = await axios.head(fileUrl, {
                headers: {
                    Pragma: 'no-cache',
                    'Cache-Control': 'no-cache'
                }
            });

            if (result.status === 200) {
                let download = document.createElement('a');
                download.setAttribute('href', fileUrl);
                download.setAttribute('download', fileUrl.substring(fileUrl.lastIndexOf('/') + 1, fileUrl.length));
                document.body.appendChild(download);
                download.click();
                document.body.removeChild(download);
                dispatch({
                    type: types.CHECK_FILE_EXISTENCE_SUCCESS
                });
            } else {
                dispatch({
                    type: types.CHECK_FILE_EXISTENCE_FAILURE
                });
            }
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.CHECK_FILE_EXISTENCE_FAILURE
            });
        }
    };
}
